import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackofficeInvoiceLineMapping  {
    _originalTypeClassName = "zERP.BO.BackofficeInvoiceLineMapping";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackofficeInvoiceLineMapping.translate = translateService;
}
this.Id = null;
this.IsPercentage = false;
this.Amount = null;
this.MappingType = null;
this.Remunerated = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsPercentage:any;
Amount:any;
MappingType:any;
Remunerated:any;
GoodBase:any;
TaxCategory:any;
static setGoodBase = ($this, value) => {
var oldValue = $this.GoodBase;
$this.GoodBase = value;
if (value != null) {
}
}
static setTaxCategory = ($this, value) => {
var oldValue = $this.TaxCategory;
$this.TaxCategory = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}